import React, { useState } from "react";
import { Loader2, Mail, Check } from "lucide-react";
import { toast } from "sonner";
import { api, formatErrorDetail } from "@/lib/api";

export default function NewsletterSignup({ variant = "footer" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email });
      setSubscribed(true);
      setEmail("");
      toast.success(data.message || "Subscribed!");
    } catch (err) {
      toast.error(formatErrorDetail(err.response?.data?.detail) || "Subscription failed");
    } finally {
      setLoading(false);
    }
  };

  if (subscribed && variant === "footer") {
    return (
      <div className="bg-saffron/10 border border-saffron/30 rounded-sm p-4 flex items-center gap-3 text-cream/90" data-testid="newsletter-success">
        <Check className="w-5 h-5 text-marigold flex-shrink-0" />
        <span className="text-sm">Subscribed! Look out for travel inspiration.</span>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="space-y-3">
      <p className="text-sm text-cream/75 font-light">
        Travel inspiration, off-beat tour ideas and exclusive offers — once a month, no spam.
      </p>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-cream/40" />
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="newsletter-email"
            placeholder="you@email.com"
            className="w-full bg-white/10 border border-white/20 pl-10 pr-3 h-11 text-sm text-cream placeholder:text-cream/40 focus:outline-none focus:border-marigold rounded-sm"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit"
          className="bg-saffron text-white px-5 h-11 text-sm font-medium uppercase tracking-wider hover:bg-saffron-600 disabled:opacity-60 rounded-sm whitespace-nowrap"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Subscribe"}
        </button>
      </div>
    </form>
  );
}
